export const PLAYER_ID = 'stream-app-player';
